module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newDy"
  }, [_c('div', {
    staticClass: "new-topitem"
  }, [_c('div', {
    staticClass: "new-screenTop"
  }, [_c('div', {
    staticClass: "topcenter"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('el-button', {
    staticClass: "con-selectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")]), _vm._v(" "), _c('el-button', {
    staticClass: "con-noSelectBtn",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('el-button', {
    staticClass: "con-noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('el-button', {
    staticClass: "con-noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "new-container"
  }, [_c('div', {
    staticClass: "new-content clearfix",
    on: {
      "click": function($event) {
        return _vm.jumpNews('1')
      }
    }
  }, [_c('img', {
    staticClass: "new-content-img",
    attrs: {
      "src": require("@/assets/gw_new1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "new-content clearfix",
    staticStyle: {
      "margin-top": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.jumpNews('2')
      }
    }
  }, [_c('img', {
    staticClass: "new-content-img",
    attrs: {
      "src": require("@/assets/gw_new2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "new-content clearfix",
    staticStyle: {
      "margin-top": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.jumpNews('3')
      }
    }
  }, [_c('img', {
    staticClass: "new-content-img",
    attrs: {
      "src": require("@/assets/gw_new4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "new-content clearfix",
    staticStyle: {
      "margin-top": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.jumpNews('4')
      }
    }
  }, [_c('img', {
    staticClass: "new-content-img",
    attrs: {
      "src": require("@/assets/gw_new3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "screen-6",
    staticStyle: {
      "height": "300px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "page-bottom clearfix"
  }, [_c('div', {
    staticClass: "page-content-container clearfix"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-right clearfix"
  }, [_c('div', {
    staticClass: "page-bottom-right-content"
  }, [_c('div', {
    staticClass: "page-bottom-content-list"
  }, [_c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")]), _vm._v(">\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-hor-split"
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _vm._m(10)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topImage"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require("@/assets/mainlogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topRight1"
  }, [_c('div', {
    staticClass: "topRight1T"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("业务咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "topRight1B"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("0536-8812347")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "right",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("@/assets/topphone.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-content-detail"
  }, [_c('div', {
    staticClass: "new-content-detail-title"
  }, [_vm._v("我市成功举办首届数字经济创新创业大赛")]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-news"
  }, [_c('span', [_vm._v("  2018年7月26日，“数动潍坊”——潍坊市首届数字经济创新创业大赛在潍坊总部基地大数据双创中心顺利举办。市委政研室（改革办）四级调研员孟志刚，市智慧办副主任胡延年，市人力资源管理中心副主任、潍坊创业大学校长孙友欣，潍坊金融控股集团党委副书记张振江出席大赛。")])]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-bottom"
  }, [_c('span', {
    staticClass: "new-content-detail-more"
  }, [_vm._v("MORE>>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-content-detail"
  }, [_c('div', {
    staticClass: "new-content-detail-title"
  }, [_vm._v("“V派”让市民畅享智慧公交")]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-news"
  }, [_c('span', [_vm._v("  目前“智慧公交”已在寿光、诸城、安丘上线。市民只需要下载\"V派\"APP,领取公交卡后，上车之前打开乘车二维码，对准设备，自动扣款，这样避免了市民因为没有零钱乘公交而烦恼，并且可以通过APP进行公交卡充值，既方便又快捷。")])]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-bottom"
  }, [_c('span', {
    staticClass: "new-content-detail-more"
  }, [_vm._v("MORE>>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-content-detail"
  }, [_c('div', {
    staticClass: "new-content-detail-title"
  }, [_vm._v("巴塞罗那问鼎，潍坊代表中国亮相世界智慧城市博览会")]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-news"
  }, [_c('span', [_vm._v("  11月16日，在全球规模最大、影响最广的智慧城市主题展会“巴塞罗那智慧城市博览会”现场，潍坊市智慧城市建设办公室主任张宝庆从颁奖人Ugo Valenti手里接过奖杯，潍坊“智慧城市3.0”斩获2017巴塞罗那世界智慧城市博览会Finalist of City Award（智慧城市提名奖）。全球仅五座城市荣获这项殊荣，潍坊是中国唯一获奖城市。")])]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-bottom"
  }, [_c('span', {
    staticClass: "new-content-detail-more"
  }, [_vm._v("MORE>>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-content-detail"
  }, [_c('div', {
    staticClass: "new-content-detail-title"
  }, [_vm._v("智慧潍坊斩获两项国际殊荣")]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-news"
  }, [_c('span', [_vm._v("  10月份，山东省潍坊市的智慧城市建设接连在国际上获得认可。10月15日，达沃斯世界经济论坛将“物联潍坊”选入4个典型案例之一，成为组委会面向各国推荐的可持续发展、高复制性的智慧城市建设案例。10月25日，巴塞罗那智慧城市博览会组委会宣布，中国潍坊从全球600余个参评城市中脱颖而出，荣获2017“智慧城市奖提名奖”，将与其他5个获奖城市共同角逐“全球智慧城市奖”。")])]), _vm._v(" "), _c('div', {
    staticClass: "new-content-detail-title-bottom"
  }, [_c('span', {
    staticClass: "new-content-detail-more"
  }, [_vm._v("MORE>>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-left"
  }, [_c('img', {
    staticClass: "page-bottom-left-logo",
    attrs: {
      "src": require("@/assets/mainlogo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("公司致力于智慧城市便民服务体系建设和运营，以“V派”城市通行证手机APP为载体，依托云计算、物联网、大数据应用和“互联网+”技术，以创建全国智慧城市样板为目标，逐步提升城市公共服务水平和居民生活品质。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_address_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("山东省潍坊市奎文区恒易宝莲金融中心A座1902")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_tel_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("0536-8812347")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_mail_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("icloudpay@icloudpay.net.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-right-code-container"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("@/assets/gw_qrcode.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("扫一扫关注我们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-44a522bd"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Guanwang/newDy.vue
// module id = 290
// module chunks = 1